import { render } from "./PermissionCard.vue?vue&type=template&id=3b94a0ea&ts=true"
import script from "./PermissionCard.vue?vue&type=script&lang=ts"
export * from "./PermissionCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__